import React from 'react';
import { Notes } from '../dashboardPage/components/notes/Notes';
import './NotesPage.css';

export const NotesPage: React.FC = () => {
    return (
        <div className="NotesPage">
            <Notes />
        </div>
    );
};
